import { ImageGallery, ImageGalleryEntry, ImageGalleryLoadElement } from "./image-gallery";
import { RequestHelper } from "../libs/request-helper";
import { HtmlLoader } from "../libs/html-loader";
import {DatareporterHelper} from "../helpers/datareporter-helper";
declare var Hyphenator:any;

export class SshgGallery extends ImageGallery {
	private static readonly youtubeGalleryClassName = "_youtubeGallery";
	public static init() {
		const galleries = document.getElementsByClassName("sshgGallery");
		const ytGalleries = document.getElementsByClassName(SshgGallery.youtubeGalleryClassName);

		if (ytGalleries.length > 0) {
			DatareporterHelper.showYtDatareporterConsent("dr_youtube_gallery");
		}

		for (let i = 0; i < galleries.length; ++i) {
			const gallery = galleries[i];
			const instance = new SshgGallery(gallery as HTMLElement);
		}
	}

	private showDownload: boolean;
	private dataDB: any;

	constructor(target: HTMLElement) {
		super(target);

		this.showDownload = target.getAttribute("data-sshg-download") == "1";
		this.dataDB = JSON.parse(target.getAttribute("data-gallery-db"));

	}

	private decode(str: string | null) {
		if(str == null) {
			return null;
		}

		return decodeURIComponent(str);
	}

	protected async loadElement(element: ImageGalleryEntry): Promise<ImageGalleryLoadElement> {
		if(element.type == "wp-img") {
			const isLandscape = window.innerWidth > window.innerHeight ? 1 : 0;

			const imgLoaderSrc = `/wp-content/themes/enfold-schauspielhaus/gallery-image.php?id=${element.src}&landscape=${isLandscape}`;

			var imageBlob = await RequestHelper.getBlob(imgLoaderSrc, false);

			if(!imageBlob.headers) {
				throw "No headers";
			}

			//Firefox requires this even for local loaded images
			const image = await HtmlLoader.loadImage(URL.createObjectURL(imageBlob.data));

			image.style.width = "auto";
			image.style.height = "auto";

			const caption = document.createElement("div");
			const headers = imageBlob.headers;

			const title = this.decode(headers.get("Sshg-Title"));
			if(title) {
				const titleDiv = document.createElement("div");
				titleDiv.classList.add("_title");
				titleDiv.innerText = title;
				caption.appendChild(titleDiv);
			}

			const subtitleDiv = document.createElement("div");
			subtitleDiv.classList.add("_subtitle");

			const copyright = this.decode(headers.get("Sshg-Copyright"));
			if(copyright) {
				const copyrightSpan = document.createElement("span");
				copyrightSpan.className = "_copyright";
				copyrightSpan.innerText = copyright;
				subtitleDiv.appendChild(copyrightSpan);
			}

			if(this.showDownload) {
				if(copyright) {
					const separatorSpan = document.createElement("span");
					separatorSpan.className = "_separator";
					separatorSpan.innerText = "|";
					subtitleDiv.appendChild(separatorSpan);
				}

				const downloadLink = document.createElement("a");
				downloadLink.href = `/wp-content/themes/enfold-schauspielhaus/gallery-image.php?id=${element.src}&asDownload=1`;;
				downloadLink.innerText = "DOWNLOAD";
				downloadLink.target = "_blank";
				subtitleDiv.appendChild(downloadLink);
			}

			caption.appendChild(subtitleDiv);
			Hyphenator.run();

			return new ImageGalleryLoadElement(image, caption.hasChildNodes() ? caption : undefined);
		}
		else if(element.type == "scloud") {
			try {
				const playerSource = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${element.src}&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true`;
				const iframe = await HtmlLoader.loadIFrame(playerSource);
				iframe.className = "_scloudEntry";

				return new ImageGalleryLoadElement(iframe);
			}
			catch(e) {
				console.log(e);
				return new ImageGalleryLoadElement(this.createErrorNode("_audioLoadError"));
			}
		} else if (element.type == "db-img") {
			const imageData = this.dataDB[element.src];
			const image = await HtmlLoader.loadImage(imageData.uri);
			const title = imageData.title;
			image.style.width = "auto";
			image.style.height = "auto";
			image.alt = title;
			image.title = title;

			const caption = document.createElement("div");


			if(title) {
				const titleDiv = document.createElement("div");
				titleDiv.classList.add("_title");
				titleDiv.innerText = title;
				caption.appendChild(titleDiv);
			}

			const subtitleDiv = document.createElement("div");
			subtitleDiv.classList.add("_subtitle");

			const copyright = imageData.copyright;
			if(copyright) {
				const copyrightSpan = document.createElement("span");
				copyrightSpan.className = "_copyright";
				copyrightSpan.innerText = copyright;
				subtitleDiv.appendChild(copyrightSpan);
			}

			if(this.showDownload) {
				if(copyright) {
					const separatorSpan = document.createElement("span");
					separatorSpan.className = "_separator";
					separatorSpan.innerText = "|";
					subtitleDiv.appendChild(separatorSpan);
				}

				const downloadLink = document.createElement("a");
				downloadLink.href = imageData.uri;
				downloadLink.innerText = "DOWNLOAD";
				downloadLink.target = "_blank";
				subtitleDiv.appendChild(downloadLink);
			}

			caption.appendChild(subtitleDiv);
			Hyphenator.run();

			return new ImageGalleryLoadElement(image, caption.hasChildNodes() ? caption : undefined);

		}

		return super.loadElement(element);
	}

	readonly closeHeight = 30;
	readonly captionHeight = 80;
	readonly navWidth = 55;
	readonly ratio = 16 / 9;
	readonly maxRationWidth = 1260;

	protected position(): void {

		if(this.galleryHost == null) {
			return;
		}

		const width = document.documentElement.clientWidth;
		const height = document.documentElement.clientHeight;

		const contentInner = this.galleryHost.getElementsByClassName("_contentInner")[0] as HTMLElement;
		const close = this.galleryHost.getElementsByClassName("_close")[0] as HTMLElement;
		const next = this.galleryHost.getElementsByClassName("_next")[0] as HTMLElement;
		const prev = this.galleryHost.getElementsByClassName("_prev")[0] as HTMLElement;
		const caption = this.galleryHost.getElementsByClassName("_caption")[0] as HTMLElement;
		const counter = this.galleryHost.getElementsByClassName("_counter")[0] as HTMLElement;

		counter.style.width = "";
		counter.style.height = "";
		counter.style.left = "";
		counter.style.top = "";

		var actualCounterWidth = counter.clientWidth;

		const maxWidth = width - 2 * this.navWidth;
		const maxHeight = height - (this.closeHeight + this.captionHeight);

		let ratioWidth: number;
		let ratioHeight: number;

		if((width / this.ratio) > height) {
			ratioHeight = maxHeight;
			ratioWidth = maxHeight * this.ratio;
		}
		else {
			ratioWidth = maxWidth;
			ratioHeight = maxWidth / this.ratio;
		}

		if(ratioWidth > this.maxRationWidth) {
			ratioWidth = this.maxRationWidth;
			ratioHeight = ratioWidth / this.ratio;
		}

		if(contentInner.classList.contains("_scloudEntry")) {
			ratioWidth = Math.min(1240, maxWidth);
			ratioHeight = Math.min(380, maxHeight);
		}

		switch(contentInner.tagName) {
			case "IMG":
				contentInner.style.maxWidth = `${maxWidth}px`;
				contentInner.style.maxHeight = `${maxHeight}px`;
				break;

			case "IFRAME":
				contentInner.style.width = `${ratioWidth}px`;
				contentInner.style.height = `${ratioHeight}px`;
				break;
		}

		window.setTimeout(() => {
			const actualWidth = contentInner.scrollWidth;
			const actualHeight = contentInner.scrollHeight;
			const topClose = ((height - (actualHeight + this.closeHeight + this.captionHeight)) / 2);
			const top = topClose + this.closeHeight;
			const topPx = `${top}px`;
			const bottomPx = `${top + actualHeight}px`;
			const left = (width - actualWidth) / 2;
			const right = left + actualWidth;
			const rightPx = `${left + actualWidth}px`;
			contentInner.style.marginTop = topPx;
			close.style.top = `${topClose}px`;
			close.style.left = `${right - close.scrollWidth}px`;
			//Ensure that there is no gap between nav buttons and content (for example if there a partial pixel width)
			next.style.left = `${right - 1}px`;
			prev.style.left = `${left - next.scrollWidth + 1}px`;
			next.style.top = prev.style.top = topPx;
			next.style.lineHeight = next.style.height = prev.style.lineHeight = prev.style.height = `${actualHeight}px`;

			caption.style.width = `${actualWidth - actualCounterWidth}px`;
			caption.style.height = `${this.captionHeight}px`;
			caption.style.left = `${left}px`;
			caption.style.top = bottomPx;

			counter.style.width = `${actualWidth}px`;
			counter.style.height = `${this.captionHeight}px`;
			counter.style.left = `${left}px`;
			counter.style.top = bottomPx;
		}, 0);
	}
}
